<ng-container>
  <div>
    <div class="heading-tab heading-mms" style="background: #f6f6f685; padding: 10px;">
      <h2> Select User Criteria </h2>
      <div>
        <button [disabled]="filterfl" nz-button nzType="link" (click)="getUsers(true, false)" nz-tooltip nzTooltipTitle="Click To Filter User Criteria"><span nz-icon nzType="filter" nzTheme="outline"></span> Filter</button>
        <button class="m-l-10" nz-button nzType="text" (click)="resetFilter()" nz-tooltip nz-tooltip nzTooltipTitle="Reset Filter Criterias"><span nz-icon nzType="undo" nzTheme="outline"></span> Reset</button>
      </div>
    </div>
    
    <div class="grid grid-2x grid -gap-20 tab grid m-t-20">
      <div class="m-b-15"><label nz-checkbox [(ngModel)]="applicableQueueFl" (ngModelChange)="crossCheckApplicalbilityandReportee($event, 'applicableQueueFl'); enableFilter()" name="applicableQueueFl" [disabled]="disableApplicableQueueFl">Applicable Queue</label></div>
      <div class="m-b-15"><label nz-checkbox [(ngModel)]="holidayFl" (ngModelChange)="enableFilter()" name="holidayFl">On Holiday</label></div>
      <div class="m-b-15"><label nz-checkbox [(ngModel)]="oooFl" (ngModelChange)="enableFilter()" name="oooFl">Out Of Office</label></div>
      <div class="m-b-15"><label nz-checkbox [(ngModel)]="reporteeFl" (ngModelChange)="crossCheckApplicalbilityandReportee($event, 'reporteeFl'); enableFilter()" name="reporteeFl">Reportee</label></div>
    </div>
  </div>

  <div>
    <div class="m-t-20 heading-mms" style="background: #f6f6f685;padding: 10px;"><h2 > Reassign Task </h2></div>
    <div class="m-t-20">
      <h4>Users</h4>
      <nz-select nzShowSearch id="users" [(ngModel)]="users" style="width:100%">
        <nz-option *ngFor="let item of listOfUsers;" nzCustomContent [nzLabel]="item?.userId" [nzValue]="item?.userId">
          <div class="flex flex-horiz-space-bw">
            <div class="flex flex-horiz-start">
              <div *ngIf="item && item.userId">
                <nz-avatar nzSize="large" [nzText]="item?.userId[0]" [ngStyle]="item.avatarStyle"></nz-avatar>
              </div>
              <div class="m-l-10">
                <div class="f-w-700">{{ item?.userId }}</div>
                <div *ngIf="item?.roleCd; else noData" class="col-grey-light">
                  <ng-container *ngFor="let role of item?.roleCd.split(','); let last = last">
                    {{ role.trim() | technicalTranslate }}<span *ngIf="!last">, </span>
                  </ng-container>
                </div>
              </div>
            </div>
           <div *ngIf="item?.holidayFl"><nz-tag nzColor="blue" [nzBordered]="false">
                <span nz-icon nzType="check-circle" nzTheme="outline"></span>
                <span>on Holiday</span></nz-tag></div>
            <div *ngIf="item?.oooFl"><nz-tag nzColor="magenta" [nzBordered]="false">
                <span nz-icon nzType="check-circle" nzTheme="outline"></span>
                <span>Out Of Office</span></nz-tag></div>
            <div *ngIf=" !item?.oooFl && !item?.holidayFl"> <nz-tag nzColor="success" [nzBordered]="false">
                <span nz-icon nzType="check-circle" nzTheme="outline"></span>
                <span>Available</span></nz-tag></div>
          </div>
        </nz-option>
      </nz-select>
    </div>
    <div class="m-t-10">
      <h4>Remarks</h4>
      <textarea nz-input id="remarks" [(ngModel)]="remarks" name="remarks"></textarea>
    </div>
  </div>
</ng-container>
<ng-container>
  

<div class="m-t-20"style="display:flex; justify-content: flex-end;">
    <div>
        <button nz-button nzType="primary" (click)="reAssignTask()">Assign</button>
        <button class="m-l-10" nz-button nzType="default" (click)="cancel()">Cancel</button>
    </div>
</div>



